import { Components, Theme } from '@mui/material';

export const muiPopper: Theme['components'] = {
  MuiPopper: {
    styleOverrides: {
      root: {
        zIndex: 1,
      },
    },
  } as Components['MuiPopper'],
};
